define('SageDotCom/Components/Listing/RelatedCustomerListing',[
    'jquery',
    'SageDotCom/Components/SlickSliderSettings',
    'slick'
], function ($, SlickSliderSettings) {
        function RelatedCustomerListing(args) {
            var scope = args.scope;
            Object.defineProperty(this, "scope", { enumerable: true, value: scope, writable: !1 });
            Object.defineProperty(this, "$scope", { enumerable: !0, value: $(scope) });
            scope.addEventListener('lazy-load-evt', this._setSlider(args.SlidesToShow));
        }

        RelatedCustomerListing.prototype._updateItems = function() {
            $(".score-slick-slider", this.scope).find('.slick-slide').each(function (i, item) {
                var h = $(item).width();
                $(item).css('height', h + 'px');
                $(item).find('.zoom-wrapper').css('height', h + 'px');
                $(item).find('.zoom-wrapper').css('width', h + 'px');
                $(item).find('.zoom-wrapper').css('max-width', 'unset!important');
                $(item).find('.cover').css('height', h + 'px');
                $(item).find('.cover').css('width', h + 'px');
                $(item).find('.customer-stories-card').css('height', h + 'px');
                $(item).find('.customer-stories-card').css('width', h + 'px');
                $(item).find('.customer-stories-card:after').css('height', h + 'px');
                $(item).find('.customer-stories-card:after').css('width', h + 'px');

            });
        }

        RelatedCustomerListing.prototype._setSlider = function(slidesToShow) {

            var self = this,
                $customerStoryItems = $(".score-slick-slider", this.scope);

            //uses same method as resourceListing as it has the exact same settings
            var slickSettings = SlickSliderSettings.getSlickSliderResourceListingSettings(slidesToShow); 

            new Promise(function(resolve, reject) {

                $customerStoryItems.slick(slickSettings);

                $customerStoryItems.on('init setPosition',
                    function() {
                        self._updateItems();
                    });

                resolve();
            });
        }

        return function initRelatedCustomerListing(args) {
            return args.IsExperienceEditorEditing === false
                ? new RelatedCustomerListing(args)
                : null;
        };
});
